import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { Checkbox } from "components/Form/SpecialButtons";
import MultipleSelect from "features/Admin/components/MultipleSelect";
import Select from "components/Form/Select";

const GeneralForm = ({ boxFactory, scannerFactory, centersMyrdv, aliquotLevelSelectList }) => (
	<div>
		<Field type="text" name="name" customlabel="Nom" component={CustomInputTextComponent} required />
		<Field type="text" name="abbreviation" customlabel="Abbréviation" component={CustomInputTextComponent} required />
		<Field type="text" name="tel" customlabel="Téléphone" component={CustomInputTextComponent} />
		<Field type="text" name="group" customlabel="Groupe" component={CustomInputTextComponent} />

		<Field customlabel="Ouvert aux patients" component={Checkbox} name="isCenter" id="isCenter" required />
		<Field customlabel="Accès à tout le catalogue" component={Checkbox} name="showAllCatalog" id="showAllCatalog" required />

		<Field customlabel="Télésecrétariat activé" component={Checkbox} name="isTvSecActivated" id="isTvSecActivated" required />

		<Field
			customlabel="Disponible pour les préleveurs externes"
			component={Checkbox}
			name="availableForExternalSamplers"
			id="availableForExternalSamplers"
			required
		/>
		<Field
			customlabel="Transmettre les dossiers du télésecrétariat à des seniors uniquement"
			component={Checkbox}
			name="tvSecToSenior"
			id="tvSecToSenior"
			required
		/>

		<Field customlabel="Thème hôpital" component={Checkbox} name="themeHospitalActivated" id="themeHospitalActivated" required />

		{/* <Field
			component={Select}
			name="myrdvId"
			customlabel="Centre MyRdv"
			placeholder="Sélectionner un centre"
			options={centersMyrdv && centersMyrdv.map((center) => {
				return {
					value: center.id,
					label: center.name,
					data: center,
				};
			})}
		/> */}
		<Field
			component={Select}
			name="aliquotLevel"
			customlabel="Aliquotage en centre"
			placeholder="Sélectionner un niveau"
			options={aliquotLevelSelectList.map((l) => {
				return {
					value: l.value,
					label: l.text,
					data: l,
				};
			})}
		/>
		<br />

		<MultipleSelect factory={boxFactory} />

		<MultipleSelect factory={scannerFactory} />
	</div>
);

export default GeneralForm;
